import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'

library.add(faQuestion)

const FindStorage = function (props) {
  let className = props.className ? 'find-storage-form ' + props.className : 'find-storage-form'

  return (
    <div className={className}>
      <form>
        <div className='input-group'>
          <input type='text' name='search' className='input-field' placeholder='Enter City, State or Zip' />
          <button type='submit' className='btn btn-primary'>
            Find Storage
          </button>
        </div>
      </form>
    </div>
  )
}

export default FindStorage
